import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { deleteSeason, getSeason } from "../../redux/actionCreator";
import {
  season_data,
  season_loading,
  season_page_details,
  season_path,
} from "../../redux/commonReducer";
import Table from "../../commonComponents/Table/Table";
import useFilter from "../../utils/Hooks/useFilter";
import Actions from "../../commonComponents/Actions/Actions";
import Input from "../../commonComponents/Input/Input";
import EntriesCounter from "../../commonComponents/EntriesCounter/EntriesCounter";
import { IMAGE_BASE_URL } from "../../constants/configuration";
import EditIcon from "../../assets/icons/EDIT.svg";
import DeleteIcon from "../../assets/icons/DELETE.svg";
import DeleteModal from "../../commonComponents/DeleteModal/DeleteModal";
import LoadingSpinner from "../../commonComponents/LoadingSpinner/LoadingSpinner";

export default function ManageSeasons() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const seasonList = useSelector(season_data);
  const pageData = useSelector(season_page_details);
  const path = useSelector(season_path);
  const loading = useSelector(season_loading);

  const initialFilter = {
    page: 0,
    perPage: 10,
    sortColumn: "updated_date",
    sortValue: -1,
    keyword: "",
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState("");

  const [filterData, setFilterData, F_navigate] = useFilter({
    initialFilter,
    dataFetch: (filter) => {
      getSearchDataHandler(filter);
    },
  });

  const getSearchDataHandler = (filter) => {
    let formData = new FormData();
    formData.append("page", filter.page);
    formData.append("perPage", filter.perPage);
    formData.append("sort_order", filter.sortValue);
    formData.append("sort_key", filter.sortColumn);
    formData.append("keyword", filter?.keyword?.trim() ?? "");
    dispatch(getSeason(formData));
  };

  const showDeletePopup = (id) => {
    setShowDeleteModal(true);
    setDeleteID(id);
  };

  function filterHandler(key, value) {
    let filter;
    switch (key) {
      case "searchBox":
        filter = { ...filterData, ...value, page: 0 };
        break;
      case "clearSearch":
        filter = initialFilter;
        break;
      case "keyword":
        filter = { ...filterData, keyword: value, page: 0 };
        break;
      case "sort":
        filter = {
          ...filterData,
          sortColumn: value.key,
          sortValue: value.value,
        };
        break;
      case "page":
        filter = { ...filterData, page: value };
        break;
      case "entries":
        filter = { ...filterData, page: 0, perPage: parseInt(value) };
        break;
      default:
    }

    if (!filter) return;
    setFilterData(filter);
    getSearchDataHandler(filter);
  }

  const handleClose = () => {
    setDeleteID("");
    setShowDeleteModal(false);
  };

  const deleteHandler = () => {
    dispatch(
      deleteSeason(deleteID, () => {
        setShowDeleteModal(false);
        setDeleteID("");
        if (
          seasonList?.length == 1 &&
          pageData?.pages > 1 &&
          filterData?.page != 0
        ) {
          setFilterData({
            ...filterData,
            page: filterData?.page - 1,
          });
          let formData = new FormData();
          formData.append("page", filterData?.page - 1);
          formData.append("perPage", filterData.perPage);
          formData.append("sort_order", filterData.sortValue);
          formData.append("sort_key", filterData.sortColumn);
          formData.append("keyword", filterData?.keyword?.trim() ?? "");
          dispatch(getSeason(formData));
        } else {
          getSearchDataHandler(filterData);
        }
      })
    );
  };

  return (
    <div className="row">
      <div className="col">
        <div className="card">
          <div className="card-body">
            <div className="table__add border-style">
              <h5 className="card-title">Manage Seasons</h5>
              <Link to="/add-season">
                <button className="btn btn-primary">Add Season</button>
              </Link>
            </div>
            <div className="search__head">
              <div className="count">
                <EntriesCounter
                  value={filterData.perPage}
                  onChange={(e) => {
                    filterHandler("entries", e);
                  }}
                />
              </div>
              <div className="search">
                <Input
                  value={filterData.keyword}
                  type="text"
                  className="css-inp-esc2 search"
                  // icon={GenericSearchIcon}
                  placeholder={"Search Here"}
                  reverse
                  width="300px"
                  field="keyword"
                  showCloseBtn
                  onChange={(e) => !e && filterHandler("keyword", e)}
                  onSubmit={(e) => {
                    filterHandler("keyword", e);
                  }}
                  onIconClick={(e) => {
                    filterHandler("keyword", e);
                  }}
                />
              </div>
            </div>
            {loading ? (
              <LoadingSpinner height={"200px"} />
            ) : (
              <div className="table-responsive">
                <Table
                  titles={[
                    {
                      title: "Sl.No",
                      key: "sl_no",
                      width: "10px",
                    },
                    {
                      title: "Icon",
                      key: "icon",
                      sort: true,
                      width: "200px",
                    },
                    {
                      title: "Name",
                      key: "name",
                      sort: true,
                      width: "200px",
                    },
                    {
                      title: "Season Months",
                      key: "season_months",
                      sort: true,
                      width: "100px",
                    },
                    { title: "Action", key: "action", width: "100px" },
                  ]}
                  content={seasonList?.map((item, i) => ({
                    sl_no: filterData.page * filterData.perPage + (i + 1),
                    name: item?.name,
                    icon: item?.icon ? (
                      <img
                        src={`${IMAGE_BASE_URL}${path}/${item?.icon}`}
                        alt=""
                      />
                    ) : (
                      <img
                        src={`/assets/img/logo.png`}
                        alt={item?.profile_image_alt}
                      />
                    ),
                    season_months: item?.season_months
                      ?.map((ele) => ele)
                      ?.join(", "),
                    action: (
                      <Actions
                        buttons={{
                          edit: EditIcon,
                          delete: DeleteIcon,
                        }}
                        onEdit={() => F_navigate(`/update-season/${item?._id}`)}
                        onDelete={() => showDeletePopup(item?._id)}
                      />
                    ),
                  }))}
                  onSort={(e) => filterHandler("sort", e)}
                  page={filterData.page}
                  pagesCount={pageData?.pages}
                  pageStatus={pageData?.status}
                  onPageChange={(e) => {
                    filterHandler("page", e.selected);
                  }}
                  sortValue={{
                    key: filterData.sortColumn,
                    value: filterData.sortValue,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleClose={handleClose}
        deleteHandler={deleteHandler}
        title={"Delete Season"}
      />
    </div>
  );
}
